import { Box, Text, Stack, Badge, Inline } from 'braid-design-system';
import type React from 'react';

interface IconRowProps {
  icon?: React.ReactNode;
  onClick?: () => void;
  label: string;
  inactive?: boolean;
  inactiveDescription?: string;
  content: React.ReactNode;
}

export const IconRow: React.FC<React.PropsWithChildren<IconRowProps>> = ({
  icon,
  onClick,
  label,
  inactive = false,
  inactiveDescription,
  content,
}) => (
  <Box
    component="button"
    width="full"
    textAlign="left"
    pointerEvents={inactive ? 'none' : undefined}
    paddingX="small"
    paddingY="xsmall"
    onClick={onClick}
    disabled={inactive}
    background={inactive ? 'neutralLight' : undefined}
    cursor={inactive ? 'default' : 'pointer'}
  >
    <Stack space="xxsmall">
      <Box display="flex" alignItems="center">
        <Box marginRight="xsmall">{icon}</Box>
        <Inline space="small" align="left">
          <Text tone={inactive ? 'secondary' : undefined}>{label}</Text>
          {label === 'Add locations' && (
            <Badge tone="promote" bleedY>
              Beta
            </Badge>
          )}
        </Inline>
      </Box>
      <Box marginLeft="large">
        {inactive && inactiveDescription !== 'undefined' && (
          <Text tone="secondary" size="small">
            {inactiveDescription}
          </Text>
        )}
        {!inactive && <>{content}</>}
      </Box>
    </Stack>
  </Box>
);
